import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import localeText from "../../../../../locale";

const StepHumanCapitalRoles = ({ data = {}, onSubmit, onBack, saving }) => {
  const [internal_hr, setInternalHr] = useState(false);
  const [second_level_contract, setSecondLevelContract] = useState(false);
  const [ongoing_labor_disputes, setOngoingLaborDisputes] = useState(false);
  const [concluded_labor_disputes, setConcludedLaborDisputes] = useState(false);
  const [union_representatives, setUnionRepresentatives] = useState({ present: false, which: "" });
  const [applied_national_labor_contract, setAppliedCcnl] = useState("");

  useEffect(() => {
    setInternalHr(!!data.internal_hr);
    setSecondLevelContract(!!data.second_level_contract);
    setOngoingLaborDisputes(!!data.ongoing_labor_disputes);
    setConcludedLaborDisputes(!!data.concluded_labor_disputes);
    setUnionRepresentatives(data.union_representatives ?? { present: false, which: "" });
    setAppliedCcnl(data.applied_national_labor_contract ?? "");
  }, [data]);

  const showWhich =
    ongoing_labor_disputes || concluded_labor_disputes || union_representatives.present;

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({
      internal_hr,
      second_level_contract,
      ongoing_labor_disputes,
      concluded_labor_disputes,
      union_representatives: {
        present: union_representatives.present,
        which: showWhich ? union_representatives.which || null : null,
      },
      applied_national_labor_contract: applied_national_labor_contract || null,
    });
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-column gap-3">
      <div>
        <h2 className="text-lg font-semibold m-0 mb-2" style={{ color: "var(--theme-text)" }}>
          {localeText("businessDiagnosisStep5Title") || "Capitale Umano Mansioni"}
        </h2>
        <p className="text-sm m-0 mb-2" style={{ color: "var(--theme-text-muted)" }}>
          {localeText("businessDiagnosisStep5Description") ||
            "Specifica le principali mansioni e responsabilità dei dipendenti, evidenziando i ruoli chiave per la crescita aziendale."}
        </p>
      </div>
      <div className="p-fluid grid" style={{rowGap: "1rem"}}>
        <div className="col-12 md:col-6 flex gap-2">
          <Checkbox
            inputId="internal_hr"
            checked={internal_hr}
            onChange={(e) => setInternalHr(e.checked)}
          />
          <label htmlFor="internal_hr">
            <div className="font-medium text-sm" style={{ color: "var(--theme-text)" }}>
              {localeText("businessDiagnosisStep5InternalHrLabel") || "H.R. interno"}
            </div>
            <div className="text-xs" style={{ color: "var(--theme-text-muted)" }}>
              {localeText("businessDiagnosisStep5InternalHrHelp") ||
                "Indicare se esiste un ufficio o responsabile HR interno."}
            </div>
          </label>
        </div>
        <div className="col-12 md:col-6 flex gap-2">
          <Checkbox
            inputId="second_level_contract"
            checked={second_level_contract}
            onChange={(e) => setSecondLevelContract(e.checked)}
          />
          <label htmlFor="second_level_contract">
            <div className="font-medium text-sm" style={{ color: "var(--theme-text)" }}>
              {localeText("businessDiagnosisStep5SecondLevelContractLabel") ||
                "Contratto II Livello"}
            </div>
            <div className="text-xs" style={{ color: "var(--theme-text-muted)" }}>
              {localeText("businessDiagnosisStep5SecondLevelContractHelp") ||
                "Indicare se l'azienda applica contratti di secondo livello (integrazioni al CCNL)."}
            </div>
          </label>
        </div>
        <div className="col-12 md:col-6 flex gap-2">
          <Checkbox
            inputId="ongoing_labor_disputes"
            checked={ongoing_labor_disputes}
            onChange={(e) => setOngoingLaborDisputes(e.checked)}
          />
          <label htmlFor="ongoing_labor_disputes">
            <div className="font-medium text-sm" style={{ color: "var(--theme-text)" }}>
              {localeText("businessDiagnosisStep5OngoingLaborDisputesLabel") ||
                "Vertenze sindacali in corso"}
            </div>
            <div className="text-xs" style={{ color: "var(--theme-text-muted)" }}>
              {localeText("businessDiagnosisStep5OngoingLaborDisputesHelp") ||
                "Indicare se ci sono vertenze sindacali attualmente in corso."}
            </div>
          </label>
        </div>
        <div className="col-12 md:col-6 flex gap-2">
          <Checkbox
            inputId="concluded_labor_disputes"
            checked={concluded_labor_disputes}
            onChange={(e) => setConcludedLaborDisputes(e.checked)}
          />
          <label htmlFor="concluded_labor_disputes">
            <div className="font-medium text-sm" style={{ color: "var(--theme-text)" }}>
              {localeText("businessDiagnosisStep5ConcludedLaborDisputesLabel") ||
                "Vertenze sindacali concluse"}
            </div>
            <div className="text-xs" style={{ color: "var(--theme-text-muted)" }}>
              {localeText("businessDiagnosisStep5ConcludedLaborDisputesHelp") ||
                "Indicare se l'azienda ha concluso vertenze sindacali in passato."}
            </div>
          </label>
        </div>
        <div className="col-12">
          <div className="flex gap-2 mb-1">
            <Checkbox
              inputId="union_representatives"
              checked={union_representatives.present}
              onChange={(e) => setUnionRepresentatives((p) => ({ ...p, present: e.checked }))}
            />
            <label htmlFor="union_representatives">
              <div className="font-medium text-sm" style={{ color: "var(--theme-text)" }}>
                {localeText("businessDiagnosisStep5UnionRepresentativesLabel") ||
                  "Rappresentanti Sindacali"}
              </div>
              <div className="text-xs" style={{ color: "var(--theme-text-muted)" }}>
                {localeText("businessDiagnosisStep5UnionRepresentativesHelp") ||
                  "Indicare se ci sono rappresentanti sindacali attivi in azienda."}
              </div>
            </label>
          </div>
          {showWhich && (
            <div className="mt-3">
              <label className="block text-sm mb-1">
                {localeText("businessDiagnosisStep5UnionRepresentativesWhichLabel") ||
                  "Se Si quali"}
              </label>
              <InputText
                value={union_representatives.which}
                onChange={(e) => setUnionRepresentatives((p) => ({ ...p, which: e.target.value }))}
                className="w-full border-round-md p-no-outline"
              />
              <small className="text-color-secondary">
                {localeText("businessDiagnosisStep5UnionRepresentativesWhichHelp") ||
                  'Se hai risposto "SI" sopra, specificare quali contratti, vertenze o rappresentanti.'}
              </small>
            </div>
          )}
        </div>
        <div className="col-12">
          <label className="block text-sm font-medium mb-1" style={{ color: "var(--theme-text)" }}>
            <span>{localeText("businessDiagnosisStep5AppliedCcnlLabel") || "CCNL Applicato"}</span>
          </label>
          <InputText
            value={applied_national_labor_contract}
            onChange={(e) => setAppliedCcnl(e.target.value)}
            className="w-full border-round-md p-no-outline"
            placeholder={
              localeText("businessDiagnosisStep5AppliedCcnlPlaceholder") ||
              "Indicare quale CCNL (Contratto Collettivo Nazionale del Lavoro) viene applicato in azienda."
            }
          />
        </div>
      </div>
      <div className="flex gap-2 flex-wrap mt-2 justify-content-end">
        {onBack && (
          <Button
            type="button"
            label={localeText("back") || "Indietro"}
            className="p-button-text"
            style={{ color: "var(--theme-primary)" }}
            onClick={onBack}
            disabled={saving}
          />
        )}
        <Button
          type="submit"
          loading={saving}
          disabled={saving}
          className="border-round-md flex align-items-center gap-2 py-3 px-3"
        >
          <span className="text-sm text-white font-medium">{localeText("saveAndContinue")}</span>
          <i className="pi pi-arrow-right text-white text-xs"></i>
        </Button>
      </div>
    </form>
  );
};

export default StepHumanCapitalRoles;
